<template>
    <div class="p-4 bg-white shadow-md">
        <h2 class="text-xl font-semibold text-gray-700 mb-4 flex items-center">
            <span class="mr-2">📊</span>
            Students by Status (Foundation & Remedial)
        </h2>

        <div v-if="hasData">
            <apexchart type="bar" height="500" :options="chartOptions" :series="series">
            </apexchart>
        </div>

        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">⚠️</div>
            <div>No data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FoundationRemedialCountByStatus",
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        series() {
            return [
                {
                    name: 'Foundation',
                    data: this.data.map(item => item.foundation_count)
                },
                {
                    name: 'Remedial',
                    data: this.data.map(item => item.remedial_count)
                }
            ];
        },
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    stacked: true,
                    toolbar: { show: false },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        dataLabels: { total: { enabled: true } }
                    }
                },
                colors: ['#4C78A8', '#F58518'],
                xaxis: {
                    categories: this.data.map(item => item.student_status_name),
                    title: { text: 'Number of Students' },
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right'
                },
                tooltip: {
                    shared: true,
                    intersect: false
                },
                dataLabels: {
                    enabled: true,
                    formatter: val => val,
                    style: {
                        fontSize: '12px',
                        fontWeight: 'bold',
                    }
                }
            };
        }
    }
}
</script>